.star {
  display: flex;
  align-items: center;
  gap: 1px;
}
